import {   INPUTBOX_SET_FOCUS,
    RESTORE_ALME_WINDOW,
    STAGE_GET_CRM,
    SET_LAUNCH_PROACTIVE_FLAG,
    SET_LAST_URL_LAUNCHED_FROM,
    SET_LAUNCH_POINT_NAME
} from '../actions/actionTypes';

//@ts-ignore
import objectPath from 'object-path';

export default function reduce(state= {}, action: any) {
    let stateLocation;
    switch (action.type) {
        case STAGE_GET_CRM:{
            const input = action.payload.input;
            const newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, { input });
            return newState;
        }
        case RESTORE_ALME_WINDOW:{
            stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation] : false,
            });
        }
        case INPUTBOX_SET_FOCUS:{
            stateLocation = action.payload.stateLocation;
            const currentInputState = Object.assign({}, state);

            objectPath.set(currentInputState, stateLocation, true);

            return currentInputState;
        }
        case SET_LAUNCH_PROACTIVE_FLAG:{
            const newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, action.payload.value);
            return newState;
        }
        case SET_LAST_URL_LAUNCHED_FROM:{
            const newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, action.payload.value);
            return newState;
        }
        case SET_LAUNCH_POINT_NAME: {
            return Object.assign({}, state, {
                ['GlobalLaunchPointName'] : action.payload.launchPointName,
            });
        }
        default:{
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./modules/window-launch/reducers/index.ts